<footer class="relative bg-[#020042] text-white pt-12 pb-0 w-full overflow-hidden">
  <!-- Background Image -->
  <div class="absolute inset-0 w-full h-full bg-cover bg-center z-0 opacity-30"
    [ngStyle]="{'background-image': 'url(' + ('assets/img/bg-footer.png' | imageConverter) + ')'}">
  </div>

  <!-- Sección principal: Logo + línea + slogan centrado ANCHO -->
  <div class="relative z-10 w-full px-6 md:px-12 lg:px-20 xl:px-28 py-16 md:py-20 flex flex-col items-center">
    <!-- Logo -->
    <picture class="mb-8">
      <source [srcset]="'assets/webp/logo-small.webp'" media="(max-width: 640px)">
      <source [srcset]="'assets/webp/logo-medium.webp'" media="(max-width: 1024px)">
      <source [srcset]="'assets/webp/logo-large.webp'" media="(max-width: 1280px)">
      <source [srcset]="'assets/webp/logo-hd.webp'" media="(min-width: 1280px)">
      <img [src]="'assets/webp/logo-small.webp'" alt="Logo arq-it"
        class="object-contain w-44 sm:w-52 md:w-60 lg:w-72 xl:w-80" loading="lazy">
    </picture>

    <!-- Línea -->
    <div class="border-t border-[#CBD6FC] w-24 md:w-28 lg:w-32 mb-8"></div>

    <!-- Slogan -->
    <p class="text-sm md:text-base lg:text-lg xl:text-xl leading-6 md:leading-7 lg:leading-8 
              text-center max-w-4xl px-4 md:px-8 font-light tracking-wide">
      {{ 'footer.slogan.part1' | translate }}
      <span class="font-semibold italic text-[#5173EF] block lg:inline-block">{{ 'footer.slogan.brand' | translate
        }}</span>
      {{ 'footer.slogan.part2' | translate }}
    </p>
  </div>

  <!-- FRANJA AZUL ABAJO full-width izquierda-derecha -->
  <div class="relative z-20 w-full bg-[#5173EF] px-8 md:px-12 lg:px-20 xl:px-28 py-2 md:py-2 lg:py-2 
              flex flex-col lg:flex-row items-center justify-between gap-4 lg:gap-12">

    <p
      class="text-white text-xs md:text-sm lg:text-base order-2 lg:order-1 text-center flex-shrink-0 font-medium tracking-wide">
      © {{ currentYear }} {{ 'footer.copyright' | translate }}
    </p>

    <p class="text-white text-xs md:text-sm lg:text-base text-center flex-shrink-0 font-medium tracking-wide">
      Santiago, Chile.
    </p>

    <p
      class="text-white text-xs md:text-sm lg:text-base order-2 lg:order-1 text-center flex-shrink-0 font-medium tracking-wide hover:underline cursor-pointer">
      info&#64;arq-it.cl
    </p>


  </div>
</footer>